import React from "react";
import { Typography } from "@/components/Typography";

import type { CouponTermsProps } from "./types";

export const CouponTerms = ({ terms, title }: CouponTermsProps) => {
  return (
    <div className="coupon-template__terms">
      <Typography
        Tag="h3"
        size="xs"
      >
        {title}
      </Typography>
      <Typography
        Tag="p"
        size="xs"
      >
        {terms}
      </Typography>
    </div>
  );
};
